export const textToPath = (text?: string) => text?.replace(/(\/)|(\s)/g, "")
